export {
  capitalizePackageManager,
  createSarifOutputForIac,
  shareResultsOutput,
  getIacDisplayedOutput,
  getIacDisplayErrorFileOutput,
} from './v1';

export {
  formatIacTestSummary,
  getIacDisplayedIssues,
  formatIacTestFailures,
  formatFailuresList,
  iacTestTitle,
  spinnerMessage,
  spinnerSuccessMessage,
  customRulesMessage,
  customRulesReportMessage,
  shouldLogUserMessages,
  formatShareResultsOutput,
  failuresTipOutput,
  IaCTestFailure,
} from './v2';
